/**
 * @flow
 * @relayHash 09f3512e28e13d6fb16c2e0eea31e8bc
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type EventOverviewContainer_node$ref = any;
type EventOverviewContainer_viewer$ref = any;
export type EventRoutes_EventOverview_QueryVariables = {|
  id: string
|};
export type EventRoutes_EventOverview_QueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: EventOverviewContainer_viewer$ref
  |},
  +node: ?{|
    +$fragmentRefs: EventOverviewContainer_node$ref
  |},
|};
export type EventRoutes_EventOverview_Query = {|
  variables: EventRoutes_EventOverview_QueryVariables,
  response: EventRoutes_EventOverview_QueryResponse,
|};
*/


/*
query EventRoutes_EventOverview_Query(
  $id: ID!
) {
  viewer {
    ...EventOverviewContainer_viewer
    id
  }
  node(id: $id) {
    __typename
    ...EventOverviewContainer_node
    id
  }
}

fragment EventOverviewContainer_viewer on User {
  id
}

fragment EventOverviewContainer_node on Event {
  id
  title
  workspaces(first: 99999) {
    edges {
      node {
        id
        title
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id",
    "type": "ID!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v5 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 99999,
    "type": "Int"
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "EventRoutes_EventOverview_Query",
  "id": null,
  "text": "query EventRoutes_EventOverview_Query(\n  $id: ID!\n) {\n  viewer {\n    ...EventOverviewContainer_viewer\n    id\n  }\n  node(id: $id) {\n    __typename\n    ...EventOverviewContainer_node\n    id\n  }\n}\n\nfragment EventOverviewContainer_viewer on User {\n  id\n}\n\nfragment EventOverviewContainer_node on Event {\n  id\n  title\n  workspaces(first: 99999) {\n    edges {\n      node {\n        id\n        title\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "EventRoutes_EventOverview_Query",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "EventOverviewContainer_viewer",
            "args": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "EventOverviewContainer_node",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "EventRoutes_EventOverview_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          v2
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "node",
        "storageKey": null,
        "args": v1,
        "concreteType": null,
        "plural": false,
        "selections": [
          v3,
          v2,
          {
            "kind": "InlineFragment",
            "type": "Event",
            "selections": [
              v4,
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "workspaces",
                "storageKey": "workspaces(first:99999)",
                "args": v5,
                "concreteType": "WorkspaceConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "WorkspaceEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Workspace",
                        "plural": false,
                        "selections": [
                          v2,
                          v4,
                          v3
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "cursor",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "pageInfo",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "endCursor",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "hasNextPage",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedHandle",
                "alias": null,
                "name": "workspaces",
                "args": v5,
                "handle": "connection",
                "key": "EventOverviewContainer_workspaces",
                "filters": null
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '8cd4326537158460731fcc0cdaa3100e';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/routes/__generated__/EventRoutes_EventOverview_Query.graphql.js